export default class TaxFactorsCalculator {

    constructor() {
        this.individualGrossIncome = 0;
        this.taxRate = 0;
        this.propertyBought = '2nd Hand';
        this.propertyTypeOptions = ['House/Townhouse', 'Unit', 'Highrise',
            'Commercial Property', 'Industrial Property'];
        this.propertyType = this.propertyTypeOptions[0];
        this.purchaseDate = 'Yes';
        this.constructionYearOptions = [];
        for (var i = 1987; i < 2019; i++) {
            this.constructionYearOptions.push(i);
        }
        this.constructionYear = this.constructionYearOptions[this.constructionYearOptions.length - 1];
        this.nearestCapitalCityOptions =
            ['Sydney', 'Melbourne', 'Perth', 'Brisbane',
                'Adelaide', 'Cairns', 'Canberra', 'Darwin', 'Hobart'];
        this.nearestCapitalCity = this.nearestCapitalCityOptions[0];
        this.standardOfFinish = 'Medium';
        this.estimatedAmount = 0;
        this.successfullyCalculated = true;
    }

    copyOtherTaxFactorsCalculator(taxFactors) {
        this.individualGrossIncome = taxFactors.individualGrossIncome;
        this.taxRate = taxFactors.taxRate;
        this.propertyBought = taxFactors.propertyBought;
        this.propertyType = taxFactors.propertyType;
        this.purchaseDate = taxFactors.purchaseDate;
        this.constructionYear = taxFactors.constructionYear;
        this.nearestCapitalCity = taxFactors.nearestCapitalCity;
        this.standardOfFinish = taxFactors.standardOfFinish;
        this.estimatedAmount = taxFactors.estimatedAmount;
        this.successfullyCalculated = taxFactors.successfullyCalculated;
    }

    setIndividualGrossIncome(individualGrossIncome) {
        this.individualGrossIncome = Number(individualGrossIncome);
        this.calcTaxRate();
    }

    getIndividualGrossIncome() {
        return this.individualGrossIncome;
    }

    getTaxRate() {
        return this.taxRate;
    }

    calcTaxRate() {
        if (this.individualGrossIncome <= 18200) {
            this.taxRate = 0;
        } else if (this.individualGrossIncome <= 37000) {
            this.taxRate = 19;
        } else if (this.individualGrossIncome <= 90000) {
            this.taxRate = 32.5
        } else if (this.individualGrossIncome <= 180000) {
            this.taxRate = 37;
        } else if (this.individualGrossIncome > 180000) {
            this.taxRate = 45;
        }

        if (Math.floor(this.taxRate) !== Number(this.taxRate)) {
            if (this.taxRate.toString().split(".")[1].length > 2) {
                this.taxRate = Number(Math.round(Number(this.taxRate+'e'+2))+'e-'+2);
            }
        }
    }

    setPropertyBought(propertyBought) {
        this.propertyBought = propertyBought;
    }

    getPropertyBought() {
        return this.propertyBought;
    }

    setPropertyType(propertyType) {
        this.propertyType = propertyType;
    }

    getPropertyType() {
        return this.propertyType;
    }

    getPropertyTypeOptions() {
        return this.propertyTypeOptions;
    }

    setPurchaseDate(purchaseDate) {
        this.purchaseDate = purchaseDate;
    }

    getPurchaseDate() {
        return this.purchaseDate;
    }

    setConstructionYear(constructionYear) {
        this.constructionYear = constructionYear;
    }

    getConstructionYear() {
        return this.constructionYear;
    }

    getConstructionYearOptions() {
        this.constructionYearOptions = [];
        var currentYear = (new Date()).getFullYear();
        this.constructionYearOptions.push('< 1987');
        for (var i = 1988; i <= currentYear; i++) {
            this.constructionYearOptions.push(i);
        }
        return this.constructionYearOptions;
    }

    setNearestCapitalCity(nearestCapitalCity) {
        this.nearestCapitalCity = nearestCapitalCity;
    }

    getNearestCapitalCity() {
        return this.nearestCapitalCity;
    }

    getNearestCapitalCityOptions() {
        return this.nearestCapitalCityOptions;
    }

    setStandardOfFinish(standardOfFinish) {
        this.standardOfFinish = standardOfFinish;
    }

    getStandardOfFinish() {
        return this.standardOfFinish;
    }

    setEstimatedAmount(estimatedAmount) {
        this.estimatedAmount = Number(estimatedAmount);
    }

    getEstimatedAmount() {
        return this.estimatedAmount;
    }

    setSuccessfullyCalculated(successfullyCalculated) {
        this.successfullyCalculated = Number(successfullyCalculated);
    }

    getSuccessfullyCalculated() {
        return this.successfullyCalculated;
    }
}


// WEBPACK FOOTER //
// ./src/Classes/TaxFactorsCalculator.js